import React, { useState } from "react";
import "./selectInputStyle.scss";

const SelectInput = ({ 
  label, 
  name, 
  value, 
  onChange, 
  options = [], 
  placeholder = "Select an option", 
  required = false,
  disabled,
  isAutoPopulated = false
}) => {
  const [isTouched, setIsTouched] = useState(false);

  return (
    <div className="form-group select-input">
      <label htmlFor={name} className="form-label">
        {label} {required && <span className="required">*</span>}
      </label>
      <select
        className={`form-select form-control ${isAutoPopulated ? 'custom-bg' : ''}`}
        id={name}
        name={name}
        value={value}
        onChange={(e) => {
          onChange(e);
          setIsTouched(true);
        }}
        onBlur={() => setIsTouched(true)}
        required={required}
        disabled={disabled}
      >
        <option value="" disabled>{placeholder}</option>
        {options.map((option, index) => (
          <option key={index} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {required && isTouched && !value && (
        <small className="error-text">This field is required</small>
      )}
    </div>
  );
};

export default SelectInput;
